import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import Linear from '../../../components/common/LinearChart';
import strings from '../../../Globalization';

const Header = ({ title, width }) => {
	const theme = useTheme();
	return (<Box
		display={'flex'}
		textAlign={'center'}
		sx={{
			borderTop: (theme) => `1px solid ${theme.palette.divider}`,
			borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
			padding: (theme) => theme.spacing(1),
			width
		}}
	>
		<Typography flex={1} textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
			{title}
		</Typography>
	</Box>)
}
const LinearChart = ({ title, data }) => {
	const theme = useTheme();
	return (
		<>
			<Header title={title} />
			<Box display={'flex'} alignItems={'center'} flexDirection={'column'} justifyContent={'center'}>
				{data.map(({ Value, IsISA, Seprater = '-', Title, SubTitle, HeaderTitle }, index) => (
					<>
						{HeaderTitle && <Header title={strings[HeaderTitle]} key={index} width={'96%'} />}
						<Box key={index} mb={2}>
							<Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
								<Typography
									bgcolor={'#205080'}
									padding={1}
									border={1}
									borderColor={theme.palette.divider}
									mr={2}
									width={100}
									color={theme.palette.background.paper}
									textAlign="center"
									fontWeight="bold"
									variant="body2"
									fontSize={11}
								>
									{`${SubTitle} ${Seprater} ${strings[Title]}`}
								</Typography>
								<Linear
									title=""
									iconWidth="10%"
									seriesName=""
									upperLimit={5}
									value={Value}
									IsISA={IsISA}
									width={300}
									mapperName="ISA"
								/>
							</Box>
						</Box>
					</>
				))}
			</Box>
		</>
	);
};

export default memo(LinearChart);